import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase } from 'angularfire2/database';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TrackingData } from './tracking';
import { UtilitiesProvider } from './utilities';
import { ENV } from '@app/env';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AuthData } from './auth';

@Injectable()

export class ZeusData {

  private clientId = ENV.client;

  constructor(
    public afAuth: AngularFireAuth,
    public database: AngularFireDatabase,
    public trackingData: TrackingData,
    private authData: AuthData,
    private utilities: UtilitiesProvider,
    private http: HttpClient
  ) { }

  /**
   * Conecta con servidor de zeus para la autenticación de un socio
   * {
        "top": {
            "parameters": {
                "vchidentificacion": string,
                "vchaccion": string,
                "vchsecuencia": string
            },
            "item": {
                "estado": "A" | "D", // Activo | Incativo
                "bloqueo": "N" | "S", // No | Si
                "motivo": string,
                "accion": string,
                "secuencia": string,
                "identificacion": string,
                "nombrecompleto": string
            },
            "status": {
                "code": "SUCESS",
                "message": null
            }
        },
        "token": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZGVudGlmaWNhY2lvbiI6Ijg2MDAwMDE2NCJ9.5UM-WXci7BU4OBX3OpbO0-6JYNy1VVj_zgSt2WxLGeg"
   * }
   * @param identificacion
   * @param accion
   * @param secuencia
   */
  public login(identificacion: string, accion: string, secuencia: string): Observable<any> {
    return this.http.post(`${ENV.zeus}/v1/zeus/login`, { identificacion, accion, secuencia })
      .pipe(
        catchError(err => [this.utilities.consoleDecorator('[ Error Zeus login ]: ', err)])
      );
  }

  /**
   * Trae todos los socios
   */
  public getAllSocios() {
    return Observable.fromPromise(this.authData.getUser().getIdToken())
      .switchMap((token: any) => {
        if (token) {
          const headers = new HttpHeaders({ 'Authorization': token });
          return this.http.get(`${ENV.zeus}/v1/zeus/socios/all/0`, { headers });
        }
      }).toPromise();
  }

  /**
   * Retorna un socio especifico
   *
   * @param identificacion
   */
  public getSocio(identificacion: string) {
    return Observable.fromPromise(this.authData.getUser().getIdToken())
      .switchMap((token: any) => {
        if (token) {
          const headers = new HttpHeaders({ 'Authorization': token });
          return this.http.get(`${ENV.zeus}/v1/zeus/socios/id/${identificacion}`, { headers });
        }
      }).toPromise();
  }
}
// end file



// WEBPACK FOOTER //
// ./src/providers/zeus.ts